(function () {
  function applyShippingLabel(root) {
    var trustSpan = root.querySelector('.gf-buybox__trust > div:nth-child(3) span');
    if (!trustSpan) return;
    var checked = root.querySelector('.gf-buybox__bundle-card input[type="radio"]:checked');
    if (!checked) return;
    trustSpan.textContent = checked.value === '2' ? 'Kostenloser Versand' : 'zzgl. Versand';
  }

  function init() {
    document.querySelectorAll('.gf-buybox').forEach(function (root) {
      applyShippingLabel(root);
      root.querySelectorAll('.gf-buybox__bundle-card input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          applyShippingLabel(root);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
